// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"de7b1194","412":"8e1d9642","414":"782faa4b","460":"49374567","609":"fa2419fd","649":"1d27c726","679":"f1238b6b","749":"9c7ed49b","962":"8088dcb1"}[chunkId] + ".chunk.js";
};